import { OptionResult } from './types';

export const defaultRequestObject = {
  pagination: { pageNumber: 1, pageSize: 5 },
};

export const deafultOptions: OptionResult = { total: 0, results: [] };

export const FILTER_CUSTOM_VALUE_TYPE = 'filter-custom-value';
